import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { UtilisateurType } from './utilisateur-type.model';
import { Entreprise } from './entreprise.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class UtilisateurBase {
    static jsonMap = {
        id: { key: 'id', optional: true },
        email: { key: 'email', optional: true, default: '' },
        nom: { key: 'nom', optional: true, default: '' },
        prenom: { key: 'prenom', optional: true, default: '' },
        type: { key: 'idType', converter: new (DataIdConverterFactory.build(UtilisateurType, 'typesUtilisateurs'))(), optional: true },
        entreprise: { key: 'entreprise', converter: new (ClassConverterFactory.build(Entreprise))(), optional: true },
        utilisateurAnpp: { key: 'utilisateurAnpp', optional: true },
        estConseillerTechnique: { key: 'estConseillerTechnique', optional: true }
    };

    public id: number;
    email: string;
    nom: string;
    prenom: string;
    public type: UtilisateurType;
    public entreprise: Entreprise;
    public utilisateurAnpp: boolean;
    public estConseillerTechnique: boolean;
}
